import React from 'react';
import { Button } from '@economic/taco';
import { Trans } from '@lingui/macro';
import welcome from './onboarding_welcome.png';

interface Props {
    displaySubcontent: boolean;
    onGettingStarted: () => void;
}

export default function StepWelcome({ displaySubcontent, onGettingStarted }: Props) {
    return (
        <div className="onboarding p-9 text-center">
            <img src={welcome} alt="" />
            <h2>
                <Trans>Welcome to e-conomic</Trans>
            </h2>

            <p>
                <Trans>
                    This 5-step guide will help set up your e-conomic account so you can get started as soon as possible.
                </Trans>
            </p>

            {displaySubcontent && (
                <p>
                    <Trans>We have sent you an email where you can create a password for your next login.</Trans>
                </p>
            )}

            <Button appearance="primary" onClick={() => onGettingStarted()}>
                <Trans>Get started</Trans>
            </Button>
        </div>
    );
}
